import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'ui';
import useIframeViewer from './useIframeViewer';

const IframeViewer = ({ url = 'https://www.example.com', size = 'md', aspectRatio = 'widescreen', title, contentGuid, courseGuid, jobGuid }) => {
  const { embedUrl, hasOpenLinkButton, iframeTitle, openLink, openLinkLabel, origin, originLabel } = useIframeViewer({
    url,
    title,
    contentGuid,
    courseGuid,
    jobGuid,
  });

  return (
    <div className={clsx('iframe-viewer', `iframe-viewer--size-${size}-${aspectRatio}`)}>
      {embedUrl && origin && <iframe src={embedUrl} title={iframeTitle}></iframe>}
      <div className="iframe-viewer__footer">
        <p className="iframe-viewer__footer-origin">{originLabel}</p>
        {title && (
          <div className="iframe-viewer__footer-link">
            <p className="iframe-viewer__footer-title">{title}</p>
            {/* Botón y no enlace: openLink registra el consumo antes de abrir la pestaña. */}
            {hasOpenLinkButton && (
              <button aria-label={openLinkLabel} className="iframe-viewer__footer-icon" onClick={openLink} type="button">
                <Icon name="external-link" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

IframeViewer.propTypes = {
  url: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  aspectRatio: PropTypes.oneOf(['widescreen', 'standard', 'square']),
  title: PropTypes.string,
  contentGuid: PropTypes.string,
  courseGuid: PropTypes.string,
  jobGuid: PropTypes.string,
};

export default IframeViewer;
